export const paymentMethods = ({ paymentMethods }) => paymentMethods.methods;
export const paymentMethodsErrors = ({ paymentMethods }) =>
  paymentMethods.errorMessage;
